import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsStopBusModel {
  id: string;
  name: string;
  date: string;
  rutas: string[];
  markerPopupText: string;
  icon: Icon;
}

export class StopBusModel extends MarkerModelBase {
  static className = 'StopBusModel';
  classProperties: IPropsStopBusModel;

  constructor(
    props: IPropsStopBusModel,
    geometry: IGeometryModel,
    lat?: number,
    lng?: number
  ) {
    super(geometry, StopBusModel.className, lat, lng);
    this.classProperties = props;

    this.geometry = geometry;
  }
}
